"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconExclamationCircle = _interopRequireDefault(require("./IconExclamationCircle"));
var Error = function Error(props) {
  return /*#__PURE__*/_react.default.createElement(_IconExclamationCircle.default, props);
};

// neither styled-components nor withIcon() HOC forward this
Error.displayName = 'IconError';
var _default = Error;
exports.default = _default;